interface FinancialYear {
  start: Date; // April 1 of the starting year
  end: Date;   // March 31 of the following year
  yearLabel: string; // Format like "2023-24"
}

export function getFinancialYear(date: Date): FinancialYear {
  const year = date.getFullYear();
  const month = date.getMonth() + 1; // Months are 0-indexed in JS
  
  // Financial year starts in April (month 4)
  // If date is April or later, it's the current financial year
  // Otherwise it's the previous financial year
  const financialYearStart = month >= 4 ? year : year - 1;
  const financialYearEnd = financialYearStart + 1;
  
  const startDate = new Date(financialYearStart, 3, 1); // April 1 (month is 0-indexed)
  const endDate = new Date(financialYearEnd, 2, 31); // March 31
  
  return {
    start: startDate,
    end: endDate,
    yearLabel: `${financialYearStart}-${financialYearEnd.toString().slice(2)}`
  };
}
export function getFinancialFullYear(date: Date): FinancialYear {
  const year = date.getFullYear();
  const month = date.getMonth() + 1; // Months are 0-indexed in JS
  
  // Financial year starts in April (month 4)
  // If date is April or later, it's the current financial year
  // Otherwise it's the previous financial year
  const financialYearStart = month >= 4 ? year : year - 1;
  const financialYearEnd = financialYearStart + 1;
  
  const startDate = new Date(financialYearStart, 3, 1); // April 1 (month is 0-indexed)
  const endDate = new Date(financialYearEnd, 2, 31); // March 31
  
  return {
    start: startDate,
    end: endDate,
    yearLabel: `${financialYearStart}-${financialYearEnd.toString()}`
  };
}